// extracted by mini-css-extract-plugin
export var compact = "FSTCO";
export var full = "emOWM";
export var mailListShimmerContainer = "ai3hL";
export var paddingFirstMessage = "ihcWa";
export var paddingMessage = "x5qK1";
export var personaCircle = "EZxd3";
export var secondRowText = "LZlN_";
export var shimmerSecondRow = "oj6f5";